<!-- Information Modal -->
<div class="modal-header">
    <app-button *ngIf="printURL" (click)="printText()">Print</app-button>
    <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="text-fragment">
        <h4 class="fragment-title">{{ role || "" }}</h4>
        <div [innerHtml]="text | sanitizeHtml: 'html'"></div>
    </div>
</div>
